<template>
  <v-select
    :label="$t('model.prop.schoolYear')"
    key="schoolYear"
    class="white"
    :items="data"
    item-text="text"
    item-value="key"
    v-model="selectedYear"
    outlined
    hide-details
    :loading="apiSchoolYear.isLoading"
  ></v-select>
</template>

<script>
export default {
  props: ["callbackSelect", "callbackError"],
  data: () => ({
    //BOC:[api]
    apiSchoolYear: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    data: [],
    schoolYear: 1,
    selectedYear: null,
    id: null,
    item: null,
    inputVal:null,
  }),

  computed: {},
  watch: {
    //BOC:[parent]
    selectedYear: function (val) {
      this.selectedYear = val
      this.item = this.$_.find(this.data, { key:  this.selectedYear });
      this.callbackSelect(this.item);
    },
    //EOC
  },
  methods: {
    name: (item) => item.name,
    async fetchYears() {
      this.apiSchoolYear.method = "get";
      this.apiSchoolYear.url =
        this.$api.servers.question +
        "/v2/syllabi" +
        "?lang=" +
        this.$_getLocale();

      this.apiSchoolYear.callbackReset = () => {
        this.apiSchoolYear.isLoading = true;
        this.apiSchoolYear.isError = false;
        this.apiSchoolYear.error = null;
      };
      this.apiSchoolYear.callbackError = (e) => {
        this.apiSchoolYear.isLoading = false;
        this.apiSchoolYear.isError = true;
        this.apiSchoolYear.error = e;
      };
      this.apiSchoolYear.callbackSuccess = (resp) => {
        this.apiSchoolYear.isLoading = false;
        resp.forEach((element, i) => {
          element.text = this.$t("string.year", { year: i + 1 });
          element.value = i + 1;
        });
        this.data = resp;
         if (this.$route.query.y) {
        this.selectedYear = this.data[this.$route.query.y - 1].key;
      } else {
       this.selectedYear = this.data[this.schoolYear - 1].key;
      }
      };
      this.apiSchoolYear.params = {
        lang: this.$_getLocale(),
      };
      await this.$api.fetch(this.apiSchoolYear);
    },
  },
  mounted() {
    this.fetchYears();
  },
};
</script>
